import {useCallback, useEffect, useRef, useState} from 'react';

export default function useSnapCarousel(count: number) {
    const viewportRef = useRef<HTMLDivElement>(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const scrollToIndex = useCallback((index: number) => {
        const cards = viewportRef.current?.querySelectorAll<HTMLElement>('[data-carousel-card]');
        cards?.[index]?.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
    }, []);

    useEffect(() => {
        const viewport = viewportRef.current;
        if(!viewport) return;
        const cards = viewport.querySelectorAll<HTMLElement>('[data-carousel-card]');
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting) setActiveIndex(Number(entry.target.getAttribute('data-carousel-index')));
            });
        }, {root: viewport, threshold: 0.6});
        cards.forEach(card => observer.observe(card));
        return () => observer.disconnect();
    }, [count]);

    return {viewportRef, activeIndex, scrollToIndex};
}
